import gql from 'graphql-tag'
import { allowedLanguages } from '@/translations'

export const eventCorrectiveActionAdmin = gql`
  query eventCorrectiveActionAdmin($id: ID!, $lang: String) {
    eventCorrectiveActionAdmin(correctiveActionId: $id) {
      id
      name
      ${allowedLanguages
        .map((lang) => `${lang}Description: description(lang: "${lang}")`)
        .join('\n')}
      coreCauses {
        id
        name
        description(lang: $lang)
      }
    }
  }
`
